import { TextWithLF } from '@doda/common/src/components/TextWithLF';
import { ArrowDown, ArrowUp, Text } from '@doda/io-react/common';
import classNames from 'classnames';
import { FC, useRef, useState, useEffect } from 'react';
import styles from './index.module.scss';

/**
 * BusinessContentProps インターフェース
 *
 * @interface BusinessContentProps
 * @property {string} businessContent - 事業内容のテキスト
 */
interface BusinessContentProps {
  businessContent: string;
}

// 6行分の高さ
const DISPLAY_HEIGHT = 143;

/**
 * BusinessContent コンポーネント
 *
 * 事業内容を表示し、テキストが6行を超える場合に「もっと見る」ボタンを表示します。
 *
 * @param {BusinessContentProps} props - コンポーネントのプロパティ
 * @returns {JSX.Element} BusinessContent コンポーネント
 */
export const BusinessContent: FC<BusinessContentProps> = ({
  businessContent,
}) => {
  const ref = useRef<HTMLDivElement>(null);

  const [isExpanded, setIsExpanded] = useState(false);
  const [isLong, setIsLong] = useState(false);

  useEffect(() => {
    if (ref.current && ref.current.scrollHeight > DISPLAY_HEIGHT) {
      setIsLong(true);
    }
  }, []);

  const toggleBusinessContent = () => {
    setIsExpanded((prev) => !prev);
  };

  const maxHeight = isExpanded ? 'none' : `${DISPLAY_HEIGHT}px`;
  const label = isExpanded ? '閉じる' : '続きを読む';

  return (
    <>
      <div
        className={styles.businessContent__text}
        style={{ maxHeight }}
        ref={ref}
      >
        <Text size="14--articlePC">
          <TextWithLF text={businessContent} />
        </Text>
      </div>
      {isLong && (
        <button
          type="button"
          onClick={toggleBusinessContent}
          className={classNames(
            styles['businessContent-relationInformationListToggleButton'],
            !isExpanded &&
              styles[
                'businessContent-relationInformationListToggleButton--blur'
              ]
          )}
        >
          <Text as="span" color="blue" weight="bold">
            {label}
          </Text>
          <span
            className={
              styles[
                'businessContent-relationInformationListToggleButton__arrowIcon'
              ]
            }
          >
            {isExpanded ? (
              <ArrowUp size="M" color="blue" />
            ) : (
              <ArrowDown size="M" color="blue" />
            )}
          </span>
        </button>
      )}
    </>
  );
};
